import { heatsRepository } from "@/repositories/heats/heats.repository";
import { RootState } from "@/store";
import { getError } from "@/utils/get-error";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "lodash-es";

export const getCurrentHeats = createAsyncThunk("@heats/current", async () => {
	const resp = await heatsRepository.getCurrentHeats();
	return resp.data;
});
export const getAllHeats = createAsyncThunk(
	"@heats/getAllHeats",
	async (_, { getState, dispatch }) => {
		const state: RootState = getState() as RootState;

		const start = state.ladles24h.filters.startDateTime;
		const end = state.ladles24h.filters.endDateTime;
		const heatName = state.ladles24h.filters.heatName;

		const resp = await heatsRepository.getAllHeats({
			start: start?.toISOString(),
			end: end?.toISOString(),
			heatName,
		});
		return resp.data;
	},
);

export const updateTap = createAsyncThunk(
	"@heats/updateTap",
	async (
		{ heatId, eafName, timeStamp, ladleId, comments }: any,
		{ dispatch, rejectWithValue },
	) => {
		try {
			const resp = await heatsRepository.updateEafTap({
				heatId,
				eafName,
				timeStamp: timeStamp,
				ladleId,
				comments,
			});
			if (resp.data.success) {
				return resp.data;
			} else {
				return rejectWithValue(resp.data.result);
			}
		} catch (e: any) {
			return rejectWithValue(get(e, "response.data.detail", e.toString()));
		}
	},
);

export const updateLadleOpen = createAsyncThunk(
	"@heats/updateLadleOpen",
	async (
		{ tundishId, heatId, casterName, timeStamp, comments }: any,
		{ dispatch, rejectWithValue },
	) => {
		try {
			const resp = await heatsRepository.updateLadleOpen({
				tundishId,
				heatId,
				casterName,
				timeStamp: timeStamp,
				comments,
			});
			if (resp.data.success) {
				return resp.data;
			} else {
				return rejectWithValue(resp.data);
			}
		} catch (e: any) {
			return rejectWithValue(get(e, "detail", get(e, "title", "")));
		}
	},
);
export const updateLadleClose = createAsyncThunk(
	"@heats/updateLadleClose",
	async (
		{ heatId, casterName, timeStamp, comments }: any,
		{ dispatch, rejectWithValue },
	) => {
		try {
			const resp = await heatsRepository.updateLadleClose({
				heatId,
				casterName,
				timeStamp,
				comments,
			});
			return resp.data;
		} catch (e) {
			return rejectWithValue(e);
		}
	},
);

export const updateStirPerformance = createAsyncThunk(
	"@heats/updateStirPerformance",
	async (
		{ heatId, stirPerformanceId, comments }: any,
		{ dispatch, rejectWithValue },
	) => {
		try {
			const resp = await heatsRepository.updateStirPerformance({
				heatId,
				stirPerformanceId,
				comments,
			});
			return resp.data;
		} catch (e) {
			return rejectWithValue(getError(e));
		}
	},
);

export const sortOrder = createAsyncThunk(
	"@heats/sortOrder",
	async ({ heatId, nextHeatId }: any) => {
		const resp = await heatsRepository.sortOrder({
			heatId,
			nextHeatId,
		});

		return resp.data;
	},
);

export const createHeat = createAsyncThunk(
	"@heats/createHeat",
	async ({ heatName, ladleId }: any, { dispatch }) => {
		let resp;
		try {
			resp = await heatsRepository.createHeat({
				heatName,
				ladleId,
			});
			return resp;
		} catch (e: any) {
			return e.response;
		}
	},
);
export const getFutureHeats = createAsyncThunk(
	"@heats/getFutureHeats",
	async () => {
		let resp;
		try {
			resp = await heatsRepository.getFutureHeats();
			return resp;
		} catch (e: any) {
			return e.response;
		}
	},
);
